/**
 * 个人产品管理系统 - 权限检查工具函数
 */
import knowledgeLotteryApi from '../services/knowledgeLotteryApi';

/**
 * 检查用户是否有个人产品管理权限
 * 系统管理员和个人产品管理员都有此权限
 */
export const hasPrivateFundPermission = async () => {
  try {
    const userStr = localStorage.getItem('user');
    if (!userStr) {
      return false;
    }

    const user = JSON.parse(userStr);
    console.log('个人产品权限检查：当前用户信息', { 
      email: user.email
    });

    // 检查用户是否有个人产品管理角色（严格按角色权限控制）
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        return false;
      }
      
      const response = await knowledgeLotteryApi.userRoleApi.getUserRoleByUserId(user._id || user.id);
      console.log('个人产品权限检查：用户角色API响应', response);
      
      if (response.success && response.data && response.data.roleId) {
        const role = response.data.roleId;
        console.log('个人产品权限检查：用户角色', { 
          roleName: role.name, 
          roleNameType: typeof role.name,
          roleNameValue: role.name,
          isActive: role.isActive, 
          permissions: role.permissions,
          fullRole: role
        });
        
        // 检查角色是否激活
        if (!role.isActive) {
          console.log('个人产品权限检查：角色未激活');
          return false;
        }
        
        // 系统管理员有所有权限（检查角色名称）
        const isSystemAdmin = role.name === '系统管理员' || String(role.name).trim() === '系统管理员';
        console.log('个人产品权限检查：是否为系统管理员', { 
          roleName: role.name, 
          isSystemAdmin,
          comparison: role.name === '系统管理员'
        });
        
        if (isSystemAdmin) {
          console.log('个人产品权限检查：系统管理员，直接通过');
          return true;
        }
        
        // 检查是否有个人产品管理权限
        const permissions = role.permissions || {};
        const privateFundPermissions = permissions.privateFund;
        const hasPermission = privateFundPermissions && privateFundPermissions.view === true;
        console.log('个人产品权限检查：权限结果', { 
          hasPrivateFundPermission: hasPermission,
          privateFundPermissions 
        });
        return hasPermission;
      } else {
        console.log('个人产品权限检查：用户没有分配角色');
        return false;
      }
    } catch (error) {
      // 如果API调用失败（比如用户未登录或没有角色），返回false但不抛出错误
      console.error('检查用户角色失败:', error);
      return false;
    }

    return false;
  } catch (error) {
    // 捕获所有错误，避免影响页面渲染
    console.error('检查个人产品管理权限失败:', error);
    return false;
  }
};
